import { LookbookBlock } from '@velasca/ui/lookbook-block'
import type { BlockLayoutProps } from './BlockLayout.types'

export const BlockLayout = ({
  layout,
  children,
  upperTitle,
  title,
  description,
}: BlockLayoutProps): JSX.Element | null => {
  if (layout === 'layout1') {
    return (
      <LookbookBlock.Layout1.Grid
        upperTitle={upperTitle ?? ''}
        title={title ?? ''}
        paragraph={description ?? ''}
      >
        {children}
      </LookbookBlock.Layout1.Grid>
    )
  }

  if (layout === 'layout2') {
    return <LookbookBlock.Layout2.Grid>{children}</LookbookBlock.Layout2.Grid>
  }

  if (layout === 'layout3') {
    return <LookbookBlock.Layout3.Grid>{children}</LookbookBlock.Layout3.Grid>
  }

  if (layout === 'layout4') {
    return <LookbookBlock.Layout4.Grid>{children}</LookbookBlock.Layout4.Grid>
  }

  if (layout === 'layout5') {
    return <LookbookBlock.Layout5.Grid>{children}</LookbookBlock.Layout5.Grid>
  }

  if (layout === 'layout6') {
    return <LookbookBlock.Layout6.Grid>{children}</LookbookBlock.Layout6.Grid>
  }

  if (layout === 'layout7') {
    return <LookbookBlock.Layout7.Grid>{children}</LookbookBlock.Layout7.Grid>
  }

  return null
}
